var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'wgt-hotTopic': true,
    'padded': _vm.value.padded
  }},[(_vm.value.title || _vm.value.subtitle)?_c('div',{staticClass:"wgt-hd"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.value.title))]),_c('span',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.value.subtitle))])]):_vm._e(),_c('div',{staticClass:"wgt-bd",class:{
      'spaced': _vm.value.spaced
    }},_vm._l((_vm.value.data),function(item,index){return _c('div',{key:index,staticClass:"topic-item",style:({
      'background': _vm.value.bgcolor
    })},[_c('span',{style:({
            'color': _vm.value.fontcolor
          })},[_vm._v(_vm._s(item.topic))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }